<template>
  <!--  普通登录页面-->
  <div class="login">
    <!-- 放logo的地方 -->
    <div class="login-logo">
      <div class="logo-img">
        <img src="./assets/Group.png" alt="" />
        <p class="logo-title">{{ $t("effortlessCareer") }}</p>
        <div class="logo-title-intro">
          <p>{{ $t("specializedCare") }}</p>
          <p>{{ $t("hiringForeigners") }}</p>
          <p>{{ $t("conciseSystem") }}</p>
          <p>{{ $t("lookWait") }}</p>
        </div>
      </div>
    </div>
    <!-- 登录的操作部分 -->
    <div class="login-main">
      <div class="login-main-box">
        <!--返回按钮-->
        <div class="box-top">
          <div class="top-icon" @click="goToIndex">
            <img src="./assets/Arrow_Right_LG.png" alt="" />
          </div>
        </div>

        <div class="bottom-box">
          <div class="bottom-box-title">
            <p class="welcom">Welcome Back!</p>
            <p class="ja-welcom">
              <span>{{ $t("memberLogin") }}</span>
              <el-dropdown class="lang-dropdown" @command="handleCommand">
                <span class="el-dropdown-link">
                  {{ lang }}<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item command="0">{{
                    $t("chinese")
                  }}</el-dropdown-item>
                  <el-dropdown-item command="1">{{
                    $t("japanese")
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </p>
          </div>
          <div class="box-form">
            <!-- 邮箱input -->
            <div class="emil-input">
              <p class="emil-input-title">
                {{ $t("emil") }}
                <span v-if="emilShow" class="emil-true-css">{{
                  $t("emilError")
                }}</span>
              </p>
              <div class="emil-input-css">
                <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="text"
                    class="emil-input-css-main"
                    v-model="emilData"
                    @blur="emailVerification"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>
            <!-- 密码input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("password") }}</p>
              <div class="emil-input-css">
                <img src="./assets/Vector.png" alt="" class="emil-icon" />
                <form class="form-input-css-main">
                  <input
                    type="password"
                    class="emil-input-css-main"
                    v-model="passwordData"
                    autocomplete="off"
                  />
                </form>
              </div>
            </div>
            <!-- 忘记密码 -->
            <div class="forget">
              <p class="forget-main" @click="forgetPassword">
                {{ $t("forgotPassword") }}
              </p>
            </div>
            <!-- 验证码input -->
            <div class="emil-input">
              <p class="emil-input-title">{{ $t("verificationCode") }}</p>
              <div class="code-main-css-flex">
                <div class="code-input-css">
                  <img src="./assets/Vector.png" alt="" class="emil-icon" />
                  <form class="form-input-css-password">
                    <input
                      class="code-input-css-main"
                      autocomplete="off"
                      v-model="verCode"
                    />
                  </form>
                </div>
                <div class="code-img-main" @click="getIdentifyCodeImg">
                  <!-- <img src="../identifyCode/img" /> -->
                  <img :src="codeImgUrl" alt="" class="code-img-url" />
                </div>
              </div>
            </div>
            <!-- 确定按钮 -->
            <div class="insure">
              <button class="insure-button" @click="login">
                {{ $t("login") }}
              </button>
            </div>
            <div class="new-goto">
              <p>
                {{ $t("clickHere")
                }}<span class="register-class" @click="goToRegister"
                  >{{ $t("registration") }}
                </span>
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 忘记密码弹出层 -->
    <div class="forget-password" v-if="dialogEmilIsSHow">
      <div class="password-dialog">
        <p class="dialog-title">{{ $t("passwordReissue") }}</p>
        <p class="dialog-hint">{{ $t("passwordReissueTitle") }}</p>
        <!-- 邮箱input -->
        <div class="dialog-emil-input">
          <div class="emil-input">
            <div class="emil-input-css">
              <img src="./assets/Vector (1).png" alt="" class="emil-icon" />
              <input
                type="text"
                class="emil-input-css-main"
                v-model="emilDialogData"
                @blur="dialogEmailVerification"
              />
            </div>
            <p class="dialog-emil-hint" v-if="dialogEmilShow">
              {{ $t("pleaseEmil") }}
            </p>
          </div>
        </div>
        <div class="dialog-button-css">
          <button class="dialog-emil-button" @click="handleCloseDialog">
            {{ $t("send") }}
          </button>
        </div>
        <div class="close-button-dialog" @click="closeButtonForget">
          <img src="./assets/Arrow_Right_LG.png" alt="" />
        </div>
      </div>
    </div>
    <!-- 发送成功弹出层 -->
    <div class="login-dialog" v-if="sentSuccess">
      <div class="dialog-main">
        <img src="./assets/Group 277.png" alt="" />
        <p>{{ $t("MailSentSuccessfully") }}</p>
        <button class="dialog-button" @click="reSuccessButton(1)">
          {{ $t("close") }}
        </button>
      </div>
    </div>
    <!-- 发送失败弹出层 -->
    <div class="login-dialog" v-if="sentError">
      <div class="dialog-main">
        <img src="./assets/Group03.png" alt="" />
        <p>{{ $t("EmailSendingFailed") }}</p>
        <button class="dialog-button1" @click="reSuccessButton(2)">
          {{ $t("close") }}
        </button>
      </div>
    </div>
  </div>
</template>
<script>
import AES from "../../js/AES";
import {
  identifyCodeImg,
  retrievePassword,
  selectJobInfo,
  userLogin
} from "../../js/api";
import axios from "axios";
import jwtDecode from "jwt-decode";
export default {
  name: "Login",
  components: {},
  data() {
    return {
      emilData: null, //登录页面邮箱input
      passwordData: null, //登录页面密码input
      verCode: null, //验证码input
      emilShow: false, //邮箱正则校验
      lang: "JP", //语言
      dialogEmilShow: false, //dialog邮箱正则校验
      emilDialogData: "", //dialog邮箱input
      dialogEmilIsSHow: false, //dialog标识
      codeImgUrl: "", //验证码图片路径
      verificationCode: "", //验证码key
      roleName: "", //区分角色
      sentSuccess: false, //邮箱验证成功
      sentError: false //邮箱验证失败
    };
  },
  created() {
    // 获取验证码
    this.getIdentifyCodeImg();
  },
  computed: {},
  mounted() {},
  methods: {
    //弹窗消失
    reSuccessButton(num) {
      if (num === 1) {
        this.sentSuccess = false;
      } else {
        this.sentError = false;
      }
    },
    // 去往注册页面
    goToRegister() {
      this.$router.push("/register");
    },
    // 返回主页面
    goToIndex() {
      console.log("回到主页面");
      this.$router.push("/");
    },
    // 登录操作
    goToLogin() {
      console.log(this.emilData, this.passwordData);
    },
    // 邮箱正则
    emailVerification() {
      var reg = /^[a-zA-Z0-9\w|\-\.]+@[a-zA-Z0-9\w|\-]+\.([a-zA-Z]{2,4}){1,32}$/;
      if (reg.test(this.emilData)) {
        this.emilShow = false;
      } else {
        this.emilShow = true;
      }
    },
    //dialog 邮箱验证
    dialogEmailVerification() {
      var reg = /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9\w|\-]+\.([a-zA-Z]{2,4}){1,32}$/;
      if (reg.test(this.emilDialogData)) {
        this.dialogEmilShow = false;
      } else {
        this.dialogEmilShow = true;
      }
    },
    //dialog 关闭
    handleCloseDialog() {
      this.retrievePassword();
      this.dialogEmilIsSHow = false;
      this.emilDialogData = "";
      this.dialogEmilShow = false;
    },
    //忘记密码dialog出现
    forgetPassword() {
      this.dialogEmilIsSHow = true;
    },
    //切换语言
    handleCommand(command) {
      if (command === "0") {
        this.$i18n.locale = "zh-CN";
        this.lang = "CN";
      } else {
        this.$i18n.locale = "ja-JP";
        this.lang = "JP";
      }
    },
    // 获取验证码
    getIdentifyCodeImg() {
      // 因为要声明blob 并没有用封装的axios写法 改用原生axios
      axios
        .get("https://rakuraku.ytttec.com/api/modules-parent/login/identifyCodeImg", {
          params: {},
          responseType: "blob" //这里是声明期望返回的数据类型，为blob
        })
        .then(res => {
          console.log("-----登录页面获取验证码接口返回值-----");
          console.log(res);
          this.codeImgUrl = window.URL.createObjectURL(res.data); //window的URL方法
          this.verificationCode = res.headers.identifycode;
        });
    },
    //找回密码
    retrievePassword() {
      var loginDTO = {
        codeKey: "",
        emailAddress: this.emilDialogData,
        language: "",
        password: "",
        verifCode: ""
      };
      retrievePassword(loginDTO)
        .then(res => {
          console.log("--------找回密码接口数据--------");
          console.log(res);
          if (res.data.code === "A0403") {
            this.$message({
              message: "邮箱未注册",
              type: "warning"
            });
          } else if (res.data.code === "A0155") {
            this.sentError = true;
            this.$message({
              message: "邮件发送失败",
              type: "warning"
            });
          } else if (res.data.code === "B0001") {
            this.$message({
              message: "系统执行出错",
              type: "warning"
            });
          } else {
            this.sentSuccess = true;
            this.$message({
              message: "邮箱校验成功,邮件已发送",
              type: "success"
            });
          }
        })
        .catch(res => {
          console.log("找回密码数据异常:", res);
        });
    },
    //用户登录
    login() {
      if (this.emilData === null) {
        this.$message({
          message: this.$t("tipsEmail"),
          type: "warning"
        });
      } else if (this.passwordData === null) {
        this.$message({
          message: this.$t("tipsPaw"),
          type: "warning"
        });
      } else if (this.verCode === null) {
        this.$message({
          message: this.$t("tipsCode"),
          type: "warning"
        });
      } else {
        var fakeInfo = {
          codeKey: this.verificationCode, //验证码key true
          emailAddress: this.emilData, //邮箱 true
          language: "", //	页面语言 false
          password: this.passwordData, //	密码 true
          verifCode: this.verCode //验证码 true
        };
        userLogin(fakeInfo)
          .then(res => {
            console.log("--------登录接口返回数据--------");
            console.log(res);
            if (res.data.code === "A0000") {
              localStorage.setItem("token", res.headers.token);
              const code = jwtDecode(res.headers.token);
              console.log(code);
              var AesInfo = AES.encrypt(JSON.stringify(code));
              localStorage.setItem("userInfo", AesInfo);

              //储存语言状态z
              localStorage.setItem("language", this.lang);

              if (code.medicalId !== "" && code.educationId === "") {
                this.$router.push("/medicalIndex");
              } else if (code.educationId !== "" && code.medicalId === "") {
                this.$router.push("/educateIndex");
              } else if (code.educationId === "" && code.medicalId === "") {
                var userInfo = localStorage.getItem("userInfo");
                const aesFecInfo = JSON.parse(AES.decrypt(userInfo));
                var roleName = aesFecInfo.roleName;
                if (
                  roleName === "educationalinstitutionuser" ||
                  roleName === "educationalinstitutionadmin"
                ) {
                  window.location.href = "#/educationalCertificationAdd";
                } else {
                  window.location.href = "#/advancedCertification";
                }
              }
            } else {
              if (res.data.code === "A0240") {
                this.$message.error(this.$t("errorCode"));
              } else if (res.data.code === "A0120") {
                this.$message.error(this.$t("errorPw"));
              } else {
                this.$message.error(res.data.data);
              }

              this.emilData = "";
              this.passwordData = "";
              this.verCode = "";
              this.getIdentifyCodeImg();
            }
          })
          .catch(res => {});
      }
    },
    //忘记密码 关闭
    closeButtonForget() {
      this.dialogEmilIsSHow = false;
      this.emilDialogData = "";
    }
  }
};
</script>
<style scoped>
.emil-true-css {
  margin-left: 10px;
  color: #f56c6c;
  width: 220px;
  text-align: right;
  display: inline-block;
}

.login {
  width: 100%;
  min-height: 550px;
  background: #51abff;
  display: flex;
  position: relative;
}

.forget-password {
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.password-dialog {
  width: 498px;
  height: 266px;
  background: #ffffff;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  padding: 15px;
  box-sizing: border-box;
  position: relative;
}

.close-button-dialog {
  overflow: hidden;
  position: absolute;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.dialog-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 34px;
  color: #686868;
}

.dialog-hint {
  margin-left: 17px;
  width: 434px;
  height: 48px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
  margin-top: 13px;
}

.dialog-emil-input {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 20px;
  height: 60px;
}

.dialog-emil-button {
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
  color: #51abff;
}

.dialog-emil-hint {
  margin-top: 5px;
  text-align: right;
  padding-right: 15px;
  box-sizing: border-box;
  color: #f56c6c;
}

.dialog-button-css {
  text-align: center;
  margin-top: 20px;
}

.login-dialog {
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(0, 0, 0, 0.6);
}

.dialog-main {
  width: 498px;
  height: 266px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: 0 12px 5px -10px rgba(0, 0, 0, 0.1), 0 0 4px 0 rgba(0, 0, 0, 0.1);
}

.dialog-main img {
  width: 66px;
  height: 66px;
  margin-bottom: 30px;
  margin-top: 37px;
}

.dialog-main p {
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #686868;
}

.dialog-button {
  margin-top: 30px;
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #51abff;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #51abff;
  cursor: pointer;
}

.dialog-button1 {
  margin-top: 30px;
  width: 118px;
  height: 24px;
  line-height: 24px;
  background: #ffffff;
  border: 1px solid #fc630c;
  box-sizing: border-box;
  border-radius: 4px;
  font-family: "Open Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
  color: #fc630c;
  cursor: pointer;
}

.login-logo {
  height: 100vh;
  width: 55%;
  position: relative;
  /* padding: 250px 0 0 110px; */
  box-sizing: border-box;
  overflow: hidden;
}
.logo-img {
  height: 400px;
  transform: translateX(10%);
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
}
.logo-title {
  font-family: "Mochiy Pop P One";
  font-style: normal;
  font-weight: 400;
  font-size: 75px;
  line-height: 139px;
  color: #ffffff;
  margin-top: -25px;
}

.logo-title-intro {
  width: 312px;
  height: 176px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 40px;
  color: #ffffff;
  margin-top: 36px;
}

.login-main {
  flex: 1;
  background: #ffffff;
  position: relative;
}

.login-main-box {
  position: absolute;
  width: 404px;
  height: 550px;
  top: 50%;
  left: 50%;
  margin-left: -75px;
  margin-top: -275px;
  background: #ffffff;
  border: 2px solid #ececec;
  box-sizing: border-box;
  border-radius: 8px;
}

.box-top {
  height: 50px;
  line-height: 50px;
  width: 100%;
}

.top-icon {
  width: 50px;
  height: 50px;
  float: right;
  text-align: center;
  cursor: pointer;
}

.bottom-box {
  height: 438px;
  padding: 0 40px;
  box-sizing: border-box;
}

.bottom-box-title {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  width: 324px;
  height: 56px;
}

.welcom {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  align-items: center;
  text-align: center;
  color: #98989e;
  margin: 3px 0px;
}

.ja-welcom {
  width: 100%;
  height: 32px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  color: #212429;
  display: flex;
}

.lang-dropdown {
  margin-left: 10px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 13.6333px;
  line-height: 16px;
  letter-spacing: 0.639063px;
  color: #686868;
  padding-top: 12px;
  box-sizing: border-box;
}

.el-dropdown-link {
  cursor: pointer;
}

.el-icon-arrow-down {
  font-size: 12px;
}

.box-form {
  margin-top: 40px;
}

.emil-input {
  padding: 0px;
  width: 324px;
  height: 66px;
  margin-bottom: 10px;
}

.emil-input-title {
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  color: #686868;
  margin: 8px 0px;
}

.emil-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 320px;
  box-sizing: border-box;
}

.emil-input-css img {
  margin-top: 13px;
}

.code-input-css {
  border: 1px solid #d8d8d8;
  box-sizing: border-box;
  border-radius: 24px;
  height: 40px;
  width: 180px;
  box-sizing: border-box;
}

.code-main-css-flex {
  display: flex;
}

.code-img-main {
  background: #f1f1f1;
  width: 100px;
  height: 40px;
  margin-left: 25px;
}

.code-img-url {
  width: 100px;
  height: 40px;
}

.emil-icon {
  margin-right: 10px;
  margin-left: 15px;
}

.emil-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  line-height: 34px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.form-input-css-main {
  width: 240px;
  margin-right: 10px;
  height: 34px;
  float: right;
  margin-top: 2px;
}

.code-input-css-main {
  width: 110px;
  height: 34px;
  line-height: 34px;
  font-family: "Inter";
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  color: #c9cfda;
}

.form-input-css-password {
  width: 110px;
  height: 34px;
  line-height: 34px;
  margin-top: 2px;
  margin-right: 10px;
  float: right;
}

.code-input-css img {
  margin-top: 12px;
}

.forget {
  overflow: hidden;
}

.forget-main {
  width: 120px;
  float: right;
  text-align: right;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 15px;
  letter-spacing: -0.02em;
  color: #51abff;
  cursor: pointer;
}

.insure {
  height: 50px;
  margin-top: 50px;
  margin-bottom: 10px;
}

.insure-button {
  cursor: pointer;
  background: #fc630c;
  border-radius: 24px;
  font-family: "Work Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 20px;
  line-height: 23px;
  text-align: center;
  letter-spacing: -0.02em;
  color: #ffffff;
  width: 320px;
  height: 50px;
}
.new-goto {
  text-align: center;
  letter-spacing: -0.02em;
  color: #c9cfda;
}
.register-class {
  cursor: pointer;
  color: #51abff;
}
</style>



// WEBPACK FOOTER //
// src/pages/login/index.vue